export default __webpack_public_path__ + "static/media/2-small.d95009b5.png";